import { BrandLogo, cn } from "@ibada/ui"

/** The app's home screen icon as a white tile, as it will look once installed. */
export function AppIconTile({ className, logoClassName }: { className?: string; logoClassName?: string }) {
  return (
    <span className={cn("flex shrink-0 items-center justify-center bg-white ring-1 ring-border/60", className)}>
      <BrandLogo variant='icon' className={cn("size-7", logoClassName)} />
    </span>
  )
}
